import React from "react";
import Checkbox from "Components/common/Checkbox/Checkbox";

class TextContaining extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            textContainingContent: ""
        }
    }

    componentDidMount() {
        this.setState({
            ...this.state, 
            textContainingContent: this.props.filterSelected && this.props.filterSelected.filter(f => f.id === "textContaining").length > 0 ? this.props.filterSelected[0].value : ""
        })
    }

    render() {
        const handleChangeTextFilter = (e) => {
            this.setState({
                ...this.state,
                textContainingContent: e.target.value
            })
        }

        const handleSubmitTextFilter = () => {
            this.props.onUpdate(this.props.filterSelected.map(f => {
                if(f.id === "textContaining") {
                    return {
                        ...f,
                        value: this.state.textContainingContent
                    }
                }

                return f;
            }));
        }

        return (
            <div class="textContainingContainer">
                <div class="filterCheckbox">
                    <Checkbox checked={!this.props.isChecked} onChange={this.props.onSelect} value={this.props.filter.id} />
                    <span>Text Containing</span>
                </div>
                {!this.props.isChecked &&
                    <div class="filterOption">
                        <input type="text" class="form-control" placeholder="Enter Value" value={this.state.textContainingContent} onChange={handleChangeTextFilter} />
                        <button class="btnDone" onClick={handleSubmitTextFilter}>Done</button>
                    </div>
                }
            </div>
        )
    }
}

export default TextContaining;